module.exports = __webpack_public_path__ + "img/unlock-keyhole.75cdc4cf.svg";